import type { ReactNode } from "react";
import { Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";

import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { accountId } = useParams();

  return (
    <Layout
      {...props}
      secondaryNavElements={
        <Fragment>
          {accountId && (
            <section>
              <NavLink end to={`/admin/account/${accountId}`}>
                Account {accountId}:
              </NavLink>
              <NavLink to={`/admin/account/${accountId}/user`}>Users</NavLink>
              <NavLink to={`/admin/account/${accountId}/deployment`}>Deployments</NavLink>
            </section>
          )}
          {props.secondaryNavElements}
        </Fragment>
      }
    />
  );
}
